import styled from 'styled-components';

export const GroupCodeSection = styled.div`
    align-items: center;
    /* border: 1px solid red; */
    display: flex;
    flex-direction: column;
    gap: 16px;
    max-width: 720px;
    position: relative;
    width: 100%;
    z-index: 1;
`;

export const GroupCodeForm = styled.form`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 12px;
    max-width: 420px;
    width: 100%;

    fieldset {
        flex: 1 1 auto;
        min-width: 0;
    }

    @media (max-width: 480px) {
        align-items: center;
        flex-direction: column;
    }
`;


export const GroupCodeError = styled.p`
    color: rgba(255, 180, 180, 0.9);
    font-size: 14px;
    margin: 0;
    text-align: center;
`;

export const PreviewPanel = styled.div`
    background: rgba(255, 255, 255, 0.08);
    border-radius: 16px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 24px;
    text-align: center;
    width: 100%;
    
`;

export const PreviewHeader = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 8px;

    h2 {
        color: #FFFFFF;
        font-family: 'Inter', sans-serif;
        font-size: 18px;
        font-weight: 700;
        margin: 0;
    }
`;

export const PreviewList = styled.ul`
    display: flex;
    flex-direction: column;
    gap: 8px;
    list-style: none;
    margin: 0;
    max-height: 320px;
    overflow-y: auto;
    padding: 0;
`;

export const PreviewCard = styled.li`
    background: rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.16);
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 12px;

    strong {
        color: #FFFFFF;
        font-size: 14px;
        font-weight: 600;
    }

    span {
        color: rgba(255, 255, 255, 0.6);
        font-size: 12px;
    }
`;

export const PreviewCta = styled.p`
    color: rgba(255, 255, 255, 0.7);
    font-size: 14px;
    margin: 8px 0 0;
    text-align: center;
`;

export const PreviewActions = styled.div`
    display: flex;
    gap: 12px;
    justify-content: center;
    width: 100%;

    @media (max-width: 480px) {
        flex-direction: column;
    }
`;
